import { Flex, Text } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

type AccountPanelProps = PropsWithChildren & {
  header: string;
};

export default function AccountPanel({ header, children }: AccountPanelProps) {
  return (
    <Flex
      flexDirection="column"
      p={{ base: 'spacer-4', md: 'spacer-6' }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      backgroundColor="background-light"
    >
      <Text variant="text-header-M" mb={{ base: 'spacer-4', lg: 'spacer-6' }}>
        {header}
      </Text>
      {children}
    </Flex>
  );
}
